import styled from 'styled-components';
import bundleBackground from '../../../images/Oval.svg';

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.15);
`;

const HeaderOvalStyled = styled.div`
  height: 25px;
  width: 100%;
  background-image: url(${bundleBackground});
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
  position: relative;
  z-index: 1;
`;

const TextStyled = styled.p`
  font-family: 'cerapro';
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #2d1441;
  margin: 40px 0px 25px 0px;
  > strong {
    font-weight: 600;
  }
`;

export { ContainerStyled, HeaderOvalStyled, TextStyled };
